export const learningHubUrls = {
  slack: 'https://kb.flair.hr/docs/customize/slack-notifications',
};
